// Pure reducer for the drawing mechanic (strokes, undo/redo, tool settings).
// Shared so the frontend canvas and the backend relay buffer apply identical
// semantics. It resolves no colors: BEGIN_STROKE carries its full style header.
export const initialDrawingState = {
    strokes: [],
    redoStack: [],
    currentStroke: null,
    colorFamily: 'blue',
    colorStop: '500',
    opacity: 1,
    thickness: 24,
};
export function drawingReducer(state, action) {
    switch (action.type) {
        case 'BEGIN_STROKE':
            return {
                ...state,
                currentStroke: {
                    points: [action.point],
                    colorHex: action.colorHex,
                    colorFamily: action.colorFamily,
                    colorStop: action.colorStop,
                    opacity: action.opacity,
                    thickness: action.thickness,
                },
            };
        case 'APPEND_POINT':
            if (!state.currentStroke) {
                return state;
            }
            return {
                ...state,
                currentStroke: {
                    ...state.currentStroke,
                    points: [...state.currentStroke.points, action.point],
                },
            };
        case 'APPEND_POINTS':
            if (!state.currentStroke || action.points.length === 0) {
                return state;
            }
            return {
                ...state,
                currentStroke: {
                    ...state.currentStroke,
                    points: [...state.currentStroke.points, ...action.points],
                },
            };
        case 'END_STROKE':
            if (!state.currentStroke) {
                return state;
            }
            return {
                ...state,
                strokes: [...state.strokes, state.currentStroke],
                redoStack: [],
                currentStroke: null,
            };
        case 'CANCEL_STROKE':
            // Discard without committing — the touch turned out to be a pinch gesture
            return { ...state, currentStroke: null };
        case 'UNDO': {
            if (state.strokes.length === 0) {
                return state;
            }
            const undone = state.strokes[state.strokes.length - 1];
            return {
                ...state,
                strokes: state.strokes.slice(0, -1),
                redoStack: [...state.redoStack, undone],
            };
        }
        case 'REDO': {
            if (state.redoStack.length === 0) {
                return state;
            }
            const restored = state.redoStack[state.redoStack.length - 1];
            return {
                ...state,
                strokes: [...state.strokes, restored],
                redoStack: state.redoStack.slice(0, -1),
            };
        }
        case 'SET_COLOR':
            return { ...state, colorFamily: action.family, colorStop: action.stop };
        case 'SET_OPACITY':
            return { ...state, opacity: action.opacity };
        case 'SET_THICKNESS':
            return { ...state, thickness: action.thickness };
        case 'CLEAR':
            return { ...state, strokes: [], redoStack: [], currentStroke: null };
        case 'HYDRATE':
            // Redo history is intentionally dropped: the snapshot is the committed
            // canvas, and undo still works on the restored strokes.
            return {
                ...state,
                strokes: action.strokes,
                currentStroke: action.currentStroke,
                redoStack: [],
            };
        default:
            return state;
    }
}
//# sourceMappingURL=drawingReducer.js.map